import React from "react"
import { MyPageHelpers } from "@macashipo/mlib"

const PageARowForm = React.lazy(() => import("./Types/PageARowForm"))
const DOPage = React.lazy(() => import("./Types/DOPage"))

const List = {
  a_row_form: PageARowForm,
  do_page: DOPage,
}
const MyPageOne = {
  init() {
    MyPageHelpers.addTypesFromListLazy(List)
  },
}

export default MyPageOne
